import { z } from "zod";

const orderNumber = z.string().trim().min(1).max(40);
export const pendingWorkOrderCheckQuerySchema = z.object({ sourceRow: z.coerce.number().int().positive(), after: orderNumber.optional(), workOrderNo: orderNumber.optional() });
export const pendingWorkOrderLookupSchema = z.object({ after: orderNumber.optional(), workOrderNo: orderNumber.optional() });
export const pendingWorkOrderCandidateSchema = z.object({
  workOrderNo: z.string().min(1),
  statusCode: z.number().int().nullable(),
  plannedQuantity: z.number().finite().nonnegative(),
  unit: z.string().min(1).nullable(),
  deliveryCountry: z.string().min(1).nullable(),
  countryMatch: z.enum(["MATCH", "MISMATCH", "UNKNOWN"]),
  salesOrder: z.string().nullable().default(null),
  salesLine: z.number().int().nullable().default(null),
  customerCode: z.string().nullable().default(null),
  customerName: z.string().nullable().default(null),
  productName: z.string().nullable().default(null),
});
export type PendingWorkOrderCandidate = z.infer<typeof pendingWorkOrderCandidateSchema>;
export const packagingBindingReviewSchema = z.object({ expectedCandidate: pendingWorkOrderCandidateSchema, comparisonConfirmed: z.literal(true) });
export const pendingWorkOrderCheckSchema = z.object({
  observedAt: z.iso.datetime(),
  sourceRow: z.number().int().positive(),
  productCode: z.string().regex(/^19\d+$/u),
  country: z.string().min(1).nullable(),
  /** True only for an incomplete source page. Further complete pages use nextCursor. */
  truncated: z.boolean(),
  nextCursor: orderNumber.nullable().default(null),
  searchedWorkOrderNo: orderNumber.nullable().default(null),
  candidates: z.array(pendingWorkOrderCandidateSchema).max(50),
});
export type PendingWorkOrderCheck = z.infer<typeof pendingWorkOrderCheckSchema>;

export const manualWorkOrderBindingSchema = z.object({
  sourceRow: z.number().int().positive(), productCode: z.string().min(1), workOrderNo: orderNumber.nullable(),
  version: z.number().int().positive(), updatedAt: z.iso.datetime(), updatedBy: z.string().min(1),
  operationId: z.uuid().nullable().default(null),
});
export const manualWorkOrderBindingStateSchema = z.object({
  canBind: z.boolean(), sourceSha256: z.string().regex(/^[a-f0-9]{64}$/u), bindings: z.array(manualWorkOrderBindingSchema),
});
export type ManualWorkOrderBindingState = z.infer<typeof manualWorkOrderBindingSchema>;
